import {
  EmployeeRole,
  ProgramExtensionStatusReason,
  ProgramTaskStatus,
} from '../enums';
import { makeArray } from './Model';
import { PodMetricsSummaryCommon } from './PodMetricsSummaryCommon';
import { PodMetricsSummaryData } from './PodMetricsSummaryData';
import { PodMetricsSummaryTask } from './PodMetricsSummaryTask';

export class PodMetricsSummary extends PodMetricsSummaryCommon {
  /** PROGRAMS */

  ccmCompletedCount = 0;

  ccmNotStartedCount = 0;

  ccmAttemptedCount = 0;

  ccmHoldCount = 0;

  rpmAtRiskCount = 0;

  rpmOnTrackCount = 0;

  rpmMetCount = 0;

  tocDueCount = 0;

  tocDuePenCount = 0;

  tocDueCompCount = 0;

  tocDueRSCount = 0;

  onHoldCCMCounts: PodMetricsSummaryData[];

  /** TASKS */

  tasksCount = 0;

  tasksCompletedCount = 0;

  taskStatusCounts: PodMetricsSummaryTask[];

  constructor(obj: any) {
    super(obj);
    this.ccmCompletedCount = obj.ccmCompletedCount;
    this.ccmNotStartedCount = obj.ccmNotStartedCount;
    this.ccmAttemptedCount = obj.ccmAttemptedCount;
    this.ccmHoldCount = obj.ccmHoldCount;
    this.rpmAtRiskCount = obj.rpmAtRiskCount;
    this.rpmOnTrackCount = obj.rpmOnTrackCount;
    this.rpmMetCount = obj.rpmMetCount;
    this.tocDueCount = obj.tocDueCount;
    this.tocDueCount = obj.tocDueCount;
    this.tocDuePenCount = obj.tocDuePenCount;
    this.tocDueCompCount = obj.tocDueCompCount;
    this.tocDueRSCount = obj.tocDueRSCount;

    this.onHoldCCMCounts = makeArray(
      obj.onHoldCCMCounts.map((state: any) => ({
        item: ProgramExtensionStatusReason.byKey[state.item as string],
        count: state.count,
      })),
      PodMetricsSummaryData,
    ).sort(PodMetricsSummaryData.sort);

    const tasks = {} as { [key: string]: PodMetricsSummaryTask };
    let statusCounts = [] as any[];
    if (obj.taskStatusAssigneeCounts) {
      statusCounts = obj.taskStatusAssigneeCounts;
    } else if (obj.taskStatusCounts) {
      Object.entries(
        obj.taskStatusCounts as {
          [taskType: string]: { item: string; count: number }[];
        },
      ).forEach(([taskType, taskStatus]) => {
        const notStarted =
          taskStatus.find(
            ({ item }) => item === ProgramTaskStatus.NOT_STARTED.value,
          )?.count || 0;
        const attempted =
          taskStatus.find(({ item }) => item === 'ATTEMPTED')?.count || 0;
        const completed =
          taskStatus.find(
            ({ item }) => item === ProgramTaskStatus.COMPLETED.value,
          )?.count || 0;
        const total = taskStatus.reduce((acc, { count }) => acc + count, 0);
        statusCounts.push({
          name: taskType,
          notStarted,
          attempted,
          completed,
          total,
        } as PodMetricsSummaryTask);
      });
    }
    statusCounts.forEach((item: any) => {
      const task = tasks[item.name];
      const employeeRole = EmployeeRole.byKey[item.employee?.role];
      const employeeLabel = [item.employee?.fullName, employeeRole?.abbr]
        .filter(Boolean)
        .join(' - ');
      if (task) {
        task.notStarted += item.notStarted;
        task.attempted += item.attempted;
        task.completed += item.completed;
        task.total += item.total;
        task.employees.push(
          new PodMetricsSummaryTask({
            ...item,
            id: item.employee?.id,
            name: employeeLabel,
          }),
        );
      } else {
        tasks[item.name] = new PodMetricsSummaryTask({
          name: item.name,
          notStarted: item.notStarted,
          attempted: item.attempted,
          completed: item.completed,
          total: item.total,
          employees: [
            new PodMetricsSummaryTask({
              ...item,
              id: item.employee?.id,
              name: employeeLabel,
            }),
          ],
        });
      }
    });

    this.taskStatusCounts = Object.values(tasks);
    this.tasksCount =
      this.taskStatusCounts?.reduce((acc, { total }) => acc + total, 0) || 0;
    this.tasksCompletedCount =
      this.taskStatusCounts?.reduce(
        (acc, { completed }) => acc + completed,
        0,
      ) || 0;
  }

  get ccmCompletedPercetage() {
    return Math.round((this.ccmCompletedCount / (this.ccmCount || 1)) * 100);
  }

  get rpmCompletedPercetage() {
    return Math.round(
      ((this.rpmMetCount + this.rpmOnTrackCount) / (this.rpmCount || 1)) * 100,
    );
  }

  get tocCompletedPercetage() {
    return Math.round((this.tocDueCompCount / (this.tocCount || 1)) * 100);
  }

  get taskCompletedPercetage() {
    return Math.round(
      (this.tasksCompletedCount / (this.tasksCount || 1)) * 100,
    );
  }
}

export default PodMetricsSummary;
